export enum PicketStyle {
  RoundPicket = 'round-picket',
  PremierPicket = 'premier-picket',
  SquarePicket = 'square-picket',
}
